import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, CircularProgress, Alert, Box, useMediaQuery, useTheme, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  showReason?: boolean;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  maxReasonLength?: number;
  onConfirm: (reason?: string) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  error?: string;
}
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  showReason = false,
  reasonLabel = 'Reason (optional)',
  reasonPlaceholder = 'Enter reason...',
  maxReasonLength = 200,
  onConfirm,
  onCancel,
  isLoading = false,
  error
}) => {
  const [reason, setReason] = useState('');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleConfirm = () => {
    onConfirm(showReason ? reason : undefined);
  };
  return <Dialog open={open} onClose={isLoading ? undefined : onCancel} maxWidth="sm" fullWidth fullScreen={fullScreen} PaperProps={{
    sx: {
      borderRadius: fullScreen ? 0 : 3,
      overflow: 'hidden'
    }
  }} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description" data-id="element-2803" data-mp="2o55fpf4tauwp">
      {fullScreen && <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      p: 1,
      borderBottom: '1px solid',
      borderColor: 'divider'
    }} data-id="element-2804" data-mp="25enzga161rs8">
          <IconButton edge="end" color="inherit" onClick={onCancel} aria-label="close" disabled={isLoading} data-id="element-2805" data-mp="3uqzm3bxrbv2n">
            <Icon icon="lucide:x" width={24} height={24} data-id="element-2806" data-mp="3pqbx0vt39ob2" />
          </IconButton>
        </Box>}
      <DialogTitle id="confirm-dialog-title" data-id="element-2807" data-mp="1o14l7zmj72bk">{title}</DialogTitle>
      <DialogContent data-id="element-2808" data-mp="1sv8w2tyx3uhx">
        <DialogContentText id="confirm-dialog-description" sx={{
        mb: 2
      }} data-id="element-2809" data-mp="1svsf6e0b0oxj">
          {message}
        </DialogContentText>
        {error && <Alert severity="error" sx={{
        mb: 2,
        borderRadius: 2
      }} variant="outlined" data-id="element-2810" data-mp="1j1s31s6lujfb">
            {error}
          </Alert>}
        {showReason && <TextField autoFocus label={reasonLabel} placeholder={reasonPlaceholder} fullWidth multiline rows={3} value={reason} onChange={e => setReason(e.target.value)} inputProps={{
        maxLength: maxReasonLength
      }} helperText={`${reason.length}/${maxReasonLength}`} disabled={isLoading} sx={{
        mt: 2
      }} data-id="element-2811" data-mp="1ww2jlm8g77aa" />}
      </DialogContent>
      <DialogActions sx={{
      p: 2,
      justifyContent: 'flex-end',
      gap: 1,
      borderTop: '1px solid',
      borderColor: 'divider'
    }} data-id="element-2812" data-mp="2znn9x03shux9">
        <Button onClick={onCancel} color="inherit" variant="outlined" disabled={isLoading} data-id="element-2813" data-mp="39mujdc7el5f3">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} color="inherit" data-id="element-2815" data-mp="2pxtwdtk375qd" /> : null} data-id="element-2814" data-mp="2gyowojwsh6cm">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default ConfirmDialog;